import { FC } from 'react'
import './index.less'
import { marginClasses } from '../../util/less-util'
import { PerSpacerProps } from '../Spacer'
import { Display } from '../../util/types'

export type BackgroundBoxHeightType =
  | 'meetingBasic'
  | 'meetingWithFooter'
  | 'meetingWithHeader'
  | 'meetingWithFooterAndHeader'
  | 'otherMeetings'
  | 'bodyBasic'
  | 'dashboard'
  | 'profileTile'
  | 'infoBox'
  | 'profileView'
  | 'tabbar'
  | 'withTabs'
  | 'withDoubleTabs'
  | 'withProfileHeaderAndTabs'
  | 'withInfoBox'
  | 'withKudosInfoBoxAndTabs'
  | 'withKudosInfoBox'
  | 'withReplyerKudosInfoBox'
  | 'withTabsAndInfoBox'
  | 'messageBox'
  | 'editImportExport'
  | 'fullPage'
  | 'fullHeight'
interface Props extends PerSpacerProps {
  r?: boolean
  rt?: boolean
  rr?: boolean
  rb?: boolean
  rl?: boolean
  rtl?: boolean
  rtr?: boolean
  rbl?: boolean
  rbr?: boolean
  id?: string
  color?: 'white' | 'white75' | 'transparent' | 'boxshadow' | 'maintenance' | 'gray-1' | 'gray-2' | 'gray-3'
  display?: Display
  height?: BackgroundBoxHeightType
  noPadding?: boolean
  noShadow?: boolean
  className?: string
  hidden?: boolean
}

const BackgroundBox: FC<Props> = ({
  r,
  rt,
  rr,
  rb,
  rl,
  rtl,
  rtr,
  rbl,
  rbr,
  m,
  mx,
  my,
  mt,
  mr,
  mb,
  ml,
  id,
  color,
  display,
  height,
  noPadding,
  noShadow,
  className,
  hidden,
  children,
}) => {
  const base = 'background-box'
  const modifiers = marginClasses(m, mb, mt, ml, mr, mx, my, 'per-spacer')

  if (r) {
    modifiers.push(base + '--r')
  }
  if (rt) {
    modifiers.push(base + '--rt')
  }
  if (rr) {
    modifiers.push(base + '--rr')
  }
  if (rb) {
    modifiers.push(base + '--rb')
  }
  if (rl) {
    modifiers.push(base + '--rl')
  }
  if (rtl) {
    modifiers.push(base + '--rtl')
  }
  if (rtr) {
    modifiers.push(base + '--rtr')
  }
  if (rbl) {
    modifiers.push(base + '--rbl')
  }
  if (rbr) {
    modifiers.push(base + '--rbr')
  }
  if (display) {
    modifiers.push(base + '--display-' + display)
  }
  if (height) {
    modifiers.push(base + '--height-' + height)
  }
  if (color) {
    modifiers.push(base + '--bg-' + color)
  }
  if (noPadding) {
    modifiers.push(base + '--noPadding')
  }
  if (noShadow) {
    modifiers.push(base + '--noShadow')
  }
  if (hidden) {
    modifiers.push(base + '--hidden')
  }
  if (className) {
    modifiers.push(className)
  }

  return (
    <div id={id} className={base + ' ' + modifiers.join(' ')}>
      {children}
    </div>
  )
}

export default BackgroundBox
